module.exports = __webpack_public_path__ + "img/icon-social-life.2bb0b7f0.svg";